import styled from 'styled-components';
import { Header } from '../../styles';

export const TrygHeader = styled(Header)`
  font-family: 'Segoe UI';
  font-size: 1.875rem;
  color: #222222;
`;
